import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DoenkidsSessionProvider } from './session.provider';

const SUPPORT_URLS = {
  NL: 'https://help-doenkids.kidskonnect.nl/hc/nl',
  BE: 'https://help-doenkids.kidskonnect.nl/hc/nl-be',
};
@Injectable({
  providedIn: 'root',
})
export class SupportProvider {
  private _showSupportItems$ = new BehaviorSubject<boolean>(true);

  public showSupportItems$ = this._showSupportItems$.asObservable();

  public supportUrl$ = new BehaviorSubject<string>(SUPPORT_URLS.NL);

  constructor(private $session: DoenkidsSessionProvider) {
    this.$session.ouCountryCode$.subscribe((countryCode) => {
      const supportUrl = SUPPORT_URLS[countryCode.toUpperCase()];
      this._showSupportItems$.next(!!supportUrl);
      this.supportUrl$.next(supportUrl || SUPPORT_URLS.NL);
    });
  }
}
